import { DatePipe } from '@angular/common'
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import {
  EquityCharacteristic,
  Portfolio,
} from 'src/app/features/portfolio/portfolio.model'
import { Footnote } from 'src/app/models/footnote.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
@Component({
  selector: 'equity-characteristic',
  templateUrl: './equity-characteristic.component.html',
  styleUrls: ['./equity-characteristic.component.scss'],
  providers: [],
})
export class EquityCharacteristicComponent implements OnInit, OnDestroy {
  @ViewChild('simpleDialogContent') simpleDialogContent: TemplateRef<any>
  @Input() portfolioModel: Portfolio
  @Input() fundId: string
  @Input() benchmarkFootNote: Footnote
  @Input() portfolioFootNote: Footnote
  equityCharacteristic: EquityCharacteristic
  noCharacteristicsData = false

  //AEM content variables
  earningsGrowthRate: AEMChunk
  peRatio: AEMChunk
  pbRatio: AEMChunk
  returnOnEquity: AEMChunk
  aemContentSub: Subscription

  dialogTitle: string
  dialogBody: string

  public datePipe: DatePipe

  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {
    this.datePipe = new DatePipe('en-US')
  }
  ngOnInit(): void {
    this.equityCharacteristic =
      this.portfolioModel?.characteristic?.equityCharacteristic

    if (
      this.equityCharacteristic !== null &&
      this.equityCharacteristic !== undefined
    ) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      this.noCharacteristicsData =
        Object.keys(this.equityCharacteristic).length === 0 ? true : false
    }

    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    this.earningsGrowthRate = this.centralContentService.getContentByBody(
      'fund_definitions_earnings_growth_rate',
      content,
    )
    this.peRatio = this.centralContentService.getContentByBody(
      'fund_definitions_pe_ratio',
      content,
    )
    this.pbRatio = this.centralContentService.getContentByBody(
      'fund_definitions_pb_ratio',
      content,
    )
    this.returnOnEquity = this.centralContentService.getContentByBody(
      'fund_definitions_return_on_equity',
      content,
    )
  }

  public setDialogInfo(title: string) {
    this.dialogTitle = title
    if (title === 'Earnings growth rate') {
      this.dialogBody = this.earningsGrowthRate?.contentValue
    } else if (title === 'Price/earnings ratio') {
      this.dialogBody = this.peRatio?.contentValue
    } else if (title === 'Price/book ratio') {
      this.dialogBody = this.pbRatio?.contentValue
    } else if (title === 'Return on equity') {
      this.dialogBody = this.returnOnEquity?.contentValue
    }
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
